import type { JSX } from 'react';

import { Button } from '@change/ds-core-ui';

import type { PreviewEmailButtonProps } from '../../types';

export function PreviewEmailButton({ disabled, onClick }: PreviewEmailButtonProps): JSX.Element | null {
	return (
		<Button
			className="w-full md:w-[149px]"
			variant="secondary"
			data-testid="preview-petition-update"
			data-qa="preview-petition-update"
			onClick={onClick}
			type="button"
			disabled={disabled}
			size="small"
		>
			Preview
		</Button>
	);
}
